import { z } from 'zod';

import { schemaApplicantAttributionBoth } from '../utils/schema.utils';

export const schemaRemindDemandedDocuments = z.object({
    attribution: schemaApplicantAttributionBoth.optional(),
});

export type SchemaRemindDemandedDocuments = z.infer<typeof schemaRemindDemandedDocuments>;
